import getCdnImg from "@casino/legacy/shared/cdn/getCdnImg";

type Props = {
  providerId: Connection;
};
const useSocialButton = ({ providerId }: Props) => {
  const socialButtonsTitles: Partial<Record<Connection, string>> = {
    metamask: "Metamask",
    facebook: "Facebook",
    telegram: "Telegram",
    twitter: "Twitter",
    "google-oauth2": "Google",
    apple: "Apple",
    line: "Line",
  };

  const title = socialButtonsTitles[providerId];
  const getImagePath = (providerName: Connection) => {
    switch (providerName) {
      case "twitter":
        return "X";
      case "line":
        return "line2";
      default:
        return providerName;
    }
  };
  const imagePath = getImagePath(providerId);

  const src = getCdnImg(imagePath, ".svg");

  return {
    title,
    src,
  };
};

export default useSocialButton;
